<nav class="pagination">
  <div class="column text-start ps-2">
    <a class="btn btn-outline-secondary btn-sm" style="background-color: #A7C04D;" (click)="selectPage(page-1)" href="javascript:void(0);">
      <i class="material-icons keyboard_arrow_left"></i>&nbsp;Prev
    </a>
  </div>
  <div class="column" style="text-align: center;">
    <ul class="pages">
      <li *ngFor="let pageNumber of pages" [class.active]="pageNumber === page" (click)="selectPage(pageNumber)">
        <a href="javascript:void(0);">{{pageNumber}}</a>
      </li>
    </ul>
  </div>
  <div class="column text-end ps-2">
    <a class="btn btn-outline-secondary btn-sm" style="background-color: #A7C04D;" (click)="selectPage(page+1)" href="javascript:void(0);">Next&nbsp;
      <i class="material-icons keyboard_arrow_right"></i>
    </a>
  </div>
</nav>